import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  text-align: center;
  padding: 2rem;
`;

const Message = styled.h3`
  font-size: 1.5rem;
  color: ${props => props.isError ? props.theme.colors.error : props.theme.colors.success};
  margin-bottom: 1.5rem;
  line-height: 1.4;
`;

const CompletionScreen = ({ hasError }) => {
  return (
    <Container>
      <Message isError={hasError}>
        {hasError 
          ? "Estamos passando por uma instabilidade temporária. Por favor, tente mais tarde"
          : "Seus dados foram enviados com sucesso! Em breve enviaremos um email com os dados do cadastro"
        }
      </Message>
    </Container>
  );
};

export default CompletionScreen;